export const Section = ({children}) => {
    return <section>{ children}</section>
}